import styled from "styled-components";

const Button = styled.button`
  background-color: #1ed760;
  max-width: 200px;
  min-width: 100px;
  height: 50px;
  border-radius: 25px;
  color: whitesmoke;
  font-weight: 700;
  font-size: 1rem;
  border: none;
  outline: none;
  text-align: center;
  cursor: pointer;
`;

export default Button;
